/*import { Dropdown } from "react-bootstrap";

const CDropdown = ({selected=0, items=["item1", "item2"], colors=[""], onSelected=(key:string | null, index:number)=>{}}) => {
    return (
        <Dropdown>
            <Dropdown.Toggle className="btn-dropdown">{items[selected]}</Dropdown.Toggle>
            <Dropdown.Menu>
                { 
                    items.map((item, i) => (
                        <Dropdown.Item as="button" 
                            eventKey={item} 
                            active={item===items[selected]}
                            style={{color: i < colors.length ? colors[i]:""}}
                            onClick={(event) => onSelected(item, i)}>
                            {item}
                        </Dropdown.Item>
                    ))
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default CDropdown;*/

import { Dropdown } from "react-bootstrap";

const CDropdown = ({
  selected = 0,
  items = ["item1", "item2"],
  colors = [""],
  onSelected = (key: string | null, index: number) => {},
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle className="btn-dropdown">
        {items[selected]}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {items.map((item, i) => (
          <Dropdown.Item
            key={`dropdown-item-${i}`}
            as="button"
            eventKey={item}
            active={item === items[selected]}
            style={{ color: i < colors.length ? colors[i] : "" }}
            onClick={() => onSelected(item, i)}
          >
            {item}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CDropdown;
